/**
 * Author : Aaditya Gandhare
 * Created : 13th Aug, 2018
 */
import { Injectable } from '@angular/core';

@Injectable()
export class BaseSettingsService {
  private env = {
		"dev": "development",
		"stg": "staging",
		"prod": "production"
  };
  public baseAPIsURL: string;
  public websiteURL: string;
  public baseHREF: string;
  public customerSessionKey: string;

  /**
   * Initialize this class
   */
  constructor() {
    // Set the env to either dev or prod;
    const ENV = this.env.prod;

    /**
     * Configure Environment Settings
     */
    switch (ENV) {
      case "development":
        this.baseAPIsURL = "http://apis.chemfield.flyingpenguins.co/";
        this.websiteURL = "http://localhost:4200/";
        this.baseHREF = "consignments/";
        this.customerSessionKey = "customer-session";
      break;

      case "staging":
        this.baseAPIsURL = "http://apis.chemfield.flyingpenguins.co/";
        this.websiteURL = "http://chemfield.flyingpenguins.co/";
        this.baseHREF = "consignments/";
        this.customerSessionKey = "customer-session";
      break;

      case "production":
        this.baseAPIsURL = "https://apis.chemfields.com/";
        this.websiteURL = "https://chemfields.com/";
        this.baseHREF = "consignments/";
        this.customerSessionKey = "customer-session";
      break;

      default:
        this.baseAPIsURL = "http://apis.chemfield.flyingpenguins.co/";
        this.websiteURL = "http://localhost:4200/";
        this.baseHREF = "consignments/";
        this.customerSessionKey = "customer-session";
      break;
    }
  }
}
